import axiosInstance from ".";

export const getHome = () => {
  return axiosInstance.get("/home");
};

export const addHome = (data) => {
  return axiosInstance.post("/home", data);
};

export const updateHome = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/home/${id}`, payload);
};
